"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackRecommendationsAction = exports.trackRecommendationsLoaded = exports.RecommendationsEventType = void 0;
const libs_tracking_events_1 = require("@hotelplan/libs.tracking-events");
var RecommendationsEventType;
(function (RecommendationsEventType) {
    RecommendationsEventType["RECOMMENDER_LOADED"] = "\uD83D\uDE80 recommender.loaded";
    RecommendationsEventType["RECOMMENDER_EMPTY"] = "\uD83D\uDE80 recommender.empty";
    RecommendationsEventType["RECOMMENDER_ACTION"] = "\uD83D\uDE80 recommender.action";
})(RecommendationsEventType || (exports.RecommendationsEventType = RecommendationsEventType = {}));
const trackRecommendationsLoaded = (payload) => {
    if (!payload)
        (0, libs_tracking_events_1.track)({
            event: RecommendationsEventType.RECOMMENDER_EMPTY,
            eventMetadata: payload,
            _clear: true,
        });
    else {
        (0, libs_tracking_events_1.track)({
            event: RecommendationsEventType.RECOMMENDER_LOADED,
            eventMetadata: payload,
            _clear: true,
        });
    }
};
exports.trackRecommendationsLoaded = trackRecommendationsLoaded;
const trackRecommendationsAction = (payload) => {
    (0, libs_tracking_events_1.track)({
        event: RecommendationsEventType.RECOMMENDER_ACTION,
        eventMetadata: payload,
        _clear: true,
    });
};
exports.trackRecommendationsAction = trackRecommendationsAction;
//# sourceMappingURL=trackRecommendations.js.map